import apiClient from './api.service';
import {
  Contractor,
  CreateContractorData,
  UpdateContractorData,
} from '../types/contractor.types';

// Phase 4 - US2: Contractor Service (T076)

class ContractorService {
  async createContractor(data: CreateContractorData): Promise<Contractor> {
    const response = await apiClient.post<{ data: Contractor }>(
      '/api/contractors',
      data
    );
    return response.data.data;
  }

  async getContractor(id: string): Promise<Contractor> {
    const response = await apiClient.get<{ data: Contractor }>(
      `/api/contractors/${id}`
    );
    return response.data.data;
  }

  async listContractors(params?: {
    active?: boolean;
    cityId?: string;
    search?: string;
    page?: number;
    limit?: number;
  }): Promise<{ data: Contractor[]; total: number; page: number; limit: number }> {
    const response = await apiClient.get<{
      data: Contractor[];
      pagination: { page: number; limit: number; total: number };
    }>('/api/contractors', { params });
    return {
      data: response.data.data,
      ...response.data.pagination,
    };
  }

  async updateContractor(
    id: string,
    data: UpdateContractorData
  ): Promise<Contractor> {
    const response = await apiClient.put<{ data: Contractor }>(
      `/api/contractors/${id}`,
      data
    );
    return response.data.data;
  }

  async deleteContractor(id: string): Promise<void> {
    await apiClient.delete(`/api/contractors/${id}`);
  }
}

export const contractorService = new ContractorService();
